import type { CrewState } from "@wearecrew/shared";

export interface PlayerView {
  id: string;
  name: string;
  color: string;
  sectionId: string;
  destinationSectionId: string;
  travelFromSectionId: string;
  travelToSectionId: string;
  travelStartedAt: number;
  travelEndsAt: number;
  ready: boolean;
  connected: boolean;
  suitOn: boolean;
  health: number;
  activeActionId: string;
  actionStartedAt: number;
  actionEndsAt: number;
}

export interface SectionView {
  id: string;
  oxygen: number;
  pressure: number;
  temperature: number;
  smoke: number;
  fire: number;
  powered: boolean;
  venting: boolean;
}

export interface LogEntryView {
  id: string;
  at: number;
  level: string;
  text: string;
}

export interface CrewSnapshot {
  phase: string;
  result: string;
  roomCode: string;
  visibility: string;
  ownerId: string;
  missionStartedAt: number;
  missionElapsed: number;
  reactorStability: number;
  hullIntegrity: number;
  oxygenLeak: boolean;
  cargoSecured: boolean;
  gridIntegrity: number;
  powerMode: string;
  alertLevel: string;
  players: PlayerView[];
  sections: SectionView[];
  logs: LogEntryView[];
}

export function snapshotCrewState(state: CrewState): CrewSnapshot {
  return {
    phase: state.phase,
    result: state.result,
    roomCode: state.roomCode,
    visibility: state.visibility,
    ownerId: state.ownerId,
    missionStartedAt: state.missionStartedAt,
    missionElapsed: state.missionElapsed,
    reactorStability: state.reactorStability,
    hullIntegrity: state.hullIntegrity,
    oxygenLeak: state.oxygenLeak,
    cargoSecured: state.cargoSecured,
    gridIntegrity: state.gridIntegrity,
    powerMode: state.powerMode,
    alertLevel: state.alertLevel,
    players: [...state.players.entries()].map(([id, player]) => ({
      id,
      name: player.name,
      color: player.color,
      sectionId: player.sectionId,
      destinationSectionId: player.destinationSectionId,
      travelFromSectionId: player.travelFromSectionId,
      travelToSectionId: player.travelToSectionId,
      travelStartedAt: player.travelStartedAt,
      travelEndsAt: player.travelEndsAt,
      ready: player.ready,
      connected: player.connected,
      suitOn: player.suitOn,
      health: player.health,
      activeActionId: player.activeActionId,
      actionStartedAt: player.actionStartedAt,
      actionEndsAt: player.actionEndsAt
    })),
    sections: [...state.sections.values()].map((section) => ({
      id: section.id,
      oxygen: section.oxygen,
      pressure: section.pressure,
      temperature: section.temperature,
      smoke: section.smoke,
      fire: section.fire,
      powered: section.powered,
      venting: section.venting
    })),
    logs: [...state.logs.values()].reverse().map((entry) => ({
      id: entry.id,
      at: entry.at,
      level: entry.level,
      text: entry.text
    }))
  };
}
